// nodemodule imports
import React from 'react';
import SwaggerUI from "swagger-ui-react"
import "swagger-ui-react/swagger-ui.css"
import styled from "styled-components";

// project imports
import swagger_doc from "../../../openapi.json"

export default () => {
  return (
    <Wrapper>
      <SwaggerUI spec={swagger_doc}/>
    </Wrapper>
  )
}


const Wrapper = styled.div(props => ({
  background: "#FFFFFF"
}));